module.exports = __webpack_public_path__ + "img/bgNaranja.3a71e7de.svg";